var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from 'js-cookie';
import { isEuMember } from 'is-eu-member';
import { getCurrentCountry } from '@vp/culture-resolution';
import { Regulations, } from '../types';
import { overrides, DefaultGdprPreferences, AllAllowedPreferences, } from '../constants';
function isGdpr(country) {
    if (!country) {
        return false;
    }
    country = country.toLowerCase();
    return (isEuMember(country) ||
        country === 'ch' ||
        country === 'no' ||
        country === 'gb');
}
function isConsentRequired() {
    var _a;
    var country;
    try {
        country = getCurrentCountry();
    }
    catch (_b) {
        return true;
    }
    var isConsentManagerDialogEnabled = !!((_a = window === null || window === void 0 ? void 0 : window.consentManager) === null || _a === void 0 ? void 0 : _a.openConsentManager);
    var shouldShowConsentManager = isGdpr(country) ||
        (isConsentManagerDialogEnabled && country.toLowerCase() !== 'us');
    return shouldShowConsentManager;
}
export function getRegulations() {
    var country;
    try {
        country = getCurrentCountry();
    }
    catch (_a) {
        return Regulations.GDPR;
    }
    if (!country) {
        return Regulations.None;
    }
    country = country.toLowerCase();
    if (country === 'us') {
        return Regulations.CCPA;
    }
    if (isGdpr(country)) {
        return Regulations.GDPR;
    }
    return Regulations.None;
}
function getConsentCookie() {
    var cookieValue = Cookies.get('tracking-preferences');
    if (!cookieValue) {
        return {};
    }
    return JSON.parse(cookieValue);
}
function getDataSale(cookie) {
    var _a, _b;
    if (cookie.version === 4) {
        return (_b = (_a = cookie.custom) === null || _a === void 0 ? void 0 : _a.datasale) !== null && _b !== void 0 ? _b : true;
    }
    if (cookie.destinations &&
        cookie.destinations.All === true &&
        cookie.destinations['Facebook Pixel'] === false) {
        return false;
    }
    return true;
}
export function applyOverrides(categories, overridesObj) {
    if (overridesObj === void 0) { overridesObj = overrides; }
    var country;
    try {
        country = getCurrentCountry();
    }
    catch (_a) {
        return categories;
    }
    if (overridesObj && Object.keys(overridesObj).includes(country)) {
        var overridenCategories_1 = Object(categories);
        Object.keys(overridesObj[country]).forEach(function (category) {
            overridenCategories_1[category] = Object(overridesObj[country])[category];
        });
        return overridenCategories_1;
    }
    return categories;
}
export function getCookieConsent() {
    var regulations = getRegulations();
    var cookie = getConsentCookie();
    if (regulations === Regulations.None) {
        return {
            hasConsent: false,
            categories: AllAllowedPreferences,
        };
    }
    if (regulations === Regulations.CCPA) {
        return {
            hasConsent: false,
            categories: __assign(__assign({}, AllAllowedPreferences), { dataSale: getDataSale(cookie) }),
        };
    }
    // GDPR
    if (cookie.custom) {
        var _a = cookie.custom, functional = _a.functional, advertising = _a.advertising, sessionreplay = _a.sessionreplay;
        var categories = {
            hasConsent: cookie.consent !== false,
            categories: {
                functional: functional !== null && functional !== void 0 ? functional : true,
                advertising: advertising !== null && advertising !== void 0 ? advertising : false,
                sessionReplay: sessionreplay !== null && sessionreplay !== void 0 ? sessionreplay : false,
                dataSale: getDataSale(cookie),
            },
        };
        return categories;
    }
    return {
        hasConsent: false,
        categories: applyOverrides(DefaultGdprPreferences),
    };
}
export function isCookieConsentPending() {
    var cookie = getConsentCookie();
    if (cookie && cookie.custom && cookie.consent !== false) {
        return false;
    }
    return isConsentRequired();
}
export function onCookieConsentProvided(callback, once) {
    if (once === void 0) { once = true; }
    if (typeof callback !== 'function') {
        return;
    }
    var cookieConsentListener = function (e) {
        var customEvent = e;
        callback(customEvent.detail);
        if (once) {
            window.removeEventListener('cookieConsentProvided', cookieConsentListener);
        }
    };
    window.addEventListener('cookieConsentProvided', cookieConsentListener);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29va2llUmVhZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9jb29raWVSZWFkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLE9BQU8sTUFBTSxXQUFXLENBQUM7QUFDaEMsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUMxQyxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSx3QkFBd0IsQ0FBQztBQUMzRCxPQUFPLEVBTUwsV0FBVyxHQUNaLE1BQU0sVUFBVSxDQUFDO0FBRWxCLE9BQU8sRUFDTCxTQUFTLEVBQ1Qsc0JBQXNCLEVBQ3RCLHFCQUFxQixHQUN0QixNQUFNLGNBQWMsQ0FBQztBQUV0QixTQUFTLE1BQU0sQ0FBQyxPQUFlO0lBQzdCLElBQUksQ0FBQyxPQUFPLEVBQUU7UUFDWixPQUFPLEtBQUssQ0FBQztLQUNkO0lBRUQsT0FBTyxHQUFHLE9BQU8sQ0FBQyxXQUFXLEVBQUUsQ0FBQztJQUVoQyxPQUFPLENBQ0wsVUFBVSxDQUFDLE9BQU8sQ0FBQztRQUNuQixPQUFPLEtBQUssSUFBSTtRQUNoQixPQUFPLEtBQUssSUFBSTtRQUNoQixPQUFPLEtBQUssSUFBSSxDQUNqQixDQUFDO0FBQ0osQ0FBQztBQUVELFNBQVMsaUJBQWlCOztJQUN4QixJQUFJLE9BQU8sQ0FBQztJQUNaLElBQUk7UUFDRixPQUFPLEdBQUcsaUJBQWlCLEVBQUUsQ0FBQztLQUMvQjtJQUFDLFdBQU07UUFDTixPQUFPLElBQUksQ0FBQztLQUNiO0lBQ0QsSUFBTSw2QkFBNkIsR0FDakMsQ0FBQyxDQUFDLENBQUEsTUFBQSxNQUFNLGFBQU4sTUFBTSx1QkFBTixNQUFNLENBQUUsY0FBYywwQ0FBRSxrQkFBa0IsQ0FBQSxDQUFDO0lBQy9DLElBQU0sd0JBQXdCLEdBQzVCLE1BQU0sQ0FBQyxPQUFPLENBQUM7UUFDZixDQUFDLDZCQUE2QixJQUFJLE9BQU8sQ0FBQyxXQUFXLEVBQUUsS0FBSyxJQUFJLENBQUMsQ0FBQztJQUVwRSxPQUFPLHdCQUF3QixDQUFDO0FBQ2xDLENBQUM7QUFFRCxNQUFNLFVBQVUsY0FBYztJQUM1QixJQUFJLE9BQU8sQ0FBQztJQUNaLElBQUk7UUFDRixPQUFPLEdBQUcsaUJBQWlCLEVBQUUsQ0FBQztLQUMvQjtJQUFDLFdBQU07UUFDTixPQUFPLFdBQVcsQ0FBQyxJQUFJLENBQUM7S0FDekI7SUFFRCxJQUFJLENBQUMsT0FBTyxFQUFFO1FBQ1osT0FBTyxXQUFXLENBQUMsSUFBSSxDQUFDO0tBQ3pCO0lBRUQsT0FBTyxHQUFHLE9BQU8sQ0FBQyxXQUFXLEVBQUUsQ0FBQztJQUNoQyxJQUFJLE9BQU8sS0FBSyxJQUFJLEVBQUU7UUFDcEIsT0FBTyxXQUFXLENBQUMsSUFBSSxDQUFDO0tBQ3pCO0lBRUQsSUFBSSxNQUFNLENBQUMsT0FBTyxDQUFDLEVBQUU7UUFDbkIsT0FBTyxXQUFXLENBQUMsSUFBSSxDQUFDO0tBQ3pCO0lBRUQsT0FBTyxXQUFXLENBQUMsSUFBSSxDQUFDO0FBQzFCLENBQUM7QUFFRCxTQUFTLGdCQUFnQjtJQUN2QixJQUFNLFdBQVcsR0FBRyxPQUFPLENBQUMsR0FBRyxDQUFDLHNCQUFzQixDQUFDLENBQUM7SUFFeEQsSUFBSSxDQUFDLFdBQVcsRUFBRTtRQUNoQixPQUFPLEVBQUUsQ0FBQztLQUNYO0lBRUQsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxDQUFDO0FBQ2pDLENBQUM7QUFFRCxTQUFTLFdBQVcsQ0FBQyxNQUEyQjs7SUFDOUMsSUFBSSxNQUFNLENBQUMsT0FBTyxLQUFLLENBQUMsRUFBRTtRQUN4QixPQUFPLE1BQUEsTUFBQSxNQUFNLENBQUMsTUFBTSwwQ0FBRSxRQUFRLG1DQUFJLElBQUksQ0FBQztLQUN4QztJQUVELElBQ0UsTUFBTSxDQUFDLFlBQVk7UUFDbkIsTUFBTSxDQUFDLFlBQVksQ0FBQyxHQUFHLEtBQUssSUFBSTtRQUNoQyxNQUFNLENBQUMsWUFBWSxDQUFDLGdCQUFnQixDQUFDLEtBQUssS0FBSyxFQUMvQztRQUNBLE9BQU8sS0FBSyxDQUFDO0tBQ2Q7SUFFRCxPQUFPLElBQUksQ0FBQztBQUNkLENBQUM7QUFFRCxNQUFNLFVBQVUsY0FBYyxDQUM1QixVQUFzQixFQUN0QixZQUF3QjtJQUF4Qiw2QkFBQSxFQUFBLHdCQUF3QjtJQUV4QixJQUFJLE9BQWUsQ0FBQztJQUNwQixJQUFJO1FBQ0YsT0FBTyxHQUFHLGlCQUFpQixFQUFFLENBQUM7S0FDL0I7SUFBQyxXQUFNO1FBQ04sT0FBTyxVQUFVLENBQUM7S0FDbkI7SUFFRCxJQUFJLFlBQVksSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsRUFBRTtRQUMvRCxJQUFNLHFCQUFtQixHQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUMsQ0FBQztRQUMvQyxNQUFNLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxVQUFDLFFBQVE7WUFDbEQscUJBQW1CLENBQUMsUUFBUSxDQUFDLEdBQUcsTUFBTSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQzFFLENBQUMsQ0FBQyxDQUFDO1FBQ0gsT0FBTyxxQkFBbUIsQ0FBQztLQUM1QjtJQUVELE9BQU8sVUFBVSxDQUFDO0FBQ3BCLENBQUM7QUFFRCxNQUFNLFVBQVUsZ0JBQWdCO0lBQzlCLElBQU0sV0FBVyxHQUFHLGNBQWMsRUFBRSxDQUFDO0lBQ3JDLElBQU0sTUFBTSxHQUFHLGdCQUFnQixFQUFFLENBQUM7SUFFbEMsSUFBSSxXQUFXLEtBQUssV0FBVyxDQUFDLElBQUksRUFBRTtRQUNwQyxPQUFPO1lBQ0wsVUFBVSxFQUFFLEtBQUs7WUFDakIsVUFBVSxFQUFFLHFCQUFxQjtTQUNsQyxDQUFDO0tBQ0g7SUFFRCxJQUFJLFdBQVcsS0FBSyxXQUFXLENBQUMsSUFBSSxFQUFFO1FBQ3BDLE9BQU87WUFDTCxVQUFVLEVBQUUsS0FBSztZQUNqQixVQUFVLHdCQUNMLHFCQUFxQixLQUN4QixRQUFRLEVBQUUsV0FBVyxDQUFDLE1BQU0sQ0FBQyxHQUM5QjtTQUNGLENBQUM7S0FDSDtJQUVELE9BQU87SUFDUCxJQUFJLE1BQU0sQ0FBQyxNQUFNLEVBQUU7UUFDWCxJQUFBLEtBQTZDLE1BQU0sQ0FBQyxNQUFNLEVBQXhELFVBQVUsZ0JBQUEsRUFBRSxXQUFXLGlCQUFBLEVBQUUsYUFBYSxtQkFBa0IsQ0FBQztRQUNqRSxJQUFNLFVBQVUsR0FBRztZQUNqQixVQUFVLEVBQUUsTUFBTSxDQUFDLE9BQU8sS0FBSyxLQUFLO1lBQ3BDLFVBQVUsRUFBRTtnQkFDVixVQUFVLEVBQUUsVUFBVSxhQUFWLFVBQVUsY0FBVixVQUFVLEdBQUksSUFBSTtnQkFDOUIsV0FBVyxFQUFFLFdBQVcsYUFBWCxXQUFXLGNBQVgsV0FBVyxHQUFJLEtBQUs7Z0JBQ2pDLGFBQWEsRUFBRSxhQUFhLGFBQWIsYUFBYSxjQUFiLGFBQWEsR0FBSSxLQUFLO2dCQUNyQyxRQUFRLEVBQUUsV0FBVyxDQUFDLE1BQU0sQ0FBQzthQUM5QjtTQUNGLENBQUM7UUFDRixPQUFPLFVBQVUsQ0FBQztLQUNuQjtJQUVELE9BQU87UUFDTCxVQUFVLEVBQUUsS0FBSztRQUNqQixVQUFVLEVBQUUsY0FBYyxDQUFDLHNCQUFzQixDQUFDO0tBQ25ELENBQUM7QUFDSixDQUFDO0FBRUQsTUFBTSxVQUFVLHNCQUFzQjtJQUNwQyxJQUFNLE1BQU0sR0FBRyxnQkFBZ0IsRUFBRSxDQUFDO0lBRWxDLElBQUksTUFBTSxJQUFJLE1BQU0sQ0FBQyxNQUFNLElBQUksTUFBTSxDQUFDLE9BQU8sS0FBSyxLQUFLLEVBQUU7UUFDdkQsT0FBTyxLQUFLLENBQUM7S0FDZDtJQUVELE9BQU8saUJBQWlCLEVBQUUsQ0FBQztBQUM3QixDQUFDO0FBRUQsTUFBTSxVQUFVLHVCQUF1QixDQUNyQyxRQUFxRCxFQUNyRCxJQUFvQjtJQUFwQixxQkFBQSxFQUFBLFdBQW9CO0lBRXBCLElBQUksT0FBTyxRQUFRLEtBQUssVUFBVSxFQUFFO1FBQ2xDLE9BQU87S0FDUjtJQUVELElBQU0scUJBQXFCLEdBQUcsVUFBQyxDQUFRO1FBQ3JDLElBQU0sV0FBVyxHQUFHLENBQStCLENBQUM7UUFDcEQsUUFBUSxDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUM3QixJQUFJLElBQUksRUFBRTtZQUNSLE1BQU0sQ0FBQyxtQkFBbUIsQ0FDeEIsdUJBQXVCLEVBQ3ZCLHFCQUFxQixDQUN0QixDQUFDO1NBQ0g7SUFDSCxDQUFDLENBQUM7SUFFRixNQUFNLENBQUMsZ0JBQWdCLENBQUMsdUJBQXVCLEVBQUUscUJBQXFCLENBQUMsQ0FBQztBQUMxRSxDQUFDIn0=